// Fungsi internal sekali parsing & ekstraksi
const extractDateParts = (date) => {
    const dDate = new Date(date);
    dDate.setHours(dDate.getHours() + 7); // optional: WIB
  
    return {
      year: dDate.getFullYear(),
      month: String(dDate.getMonth() + 1).padStart(2, '0'),
      day: String(dDate.getDate()).padStart(2, '0'),
      hours: String(dDate.getHours()).padStart(2, '0'),
      minutes: String(dDate.getMinutes()).padStart(2, '0'),
      seconds: String(dDate.getSeconds()).padStart(2, '0'),
    };
  };
  
  // Tanggal saja
  export const getFormattedDate = (date) => {
    const { day, month, year } = extractDateParts(date);
    return `${day}-${month}-${year}`;
  };
  
  // Tanggal + waktu
  export const getFormattedDateTime = (date) => {
    const { day, month, year, hours, minutes, seconds } = extractDateParts(date);
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

